import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { AddressState } from ".";

export const useAddressReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.address);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<AddressState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<AddressState>;
};
